// Import components
const COMPONENTS = {
  boxes: {
    func: () => import(/* webpackChunkName: "boxes" */ './components/boxes.js'),
    selector: '.boxes',
  },
  click: {
    func: () => import(/* webpackChunkName: "click" */ './components/click.js'),
    selector: 'nav',
  },
  video: {
    func: () => import(/* webpackChunkName: "video" */ './components/video.js'),
    selector: '[data-video-id]',
  },
  testimonials: {
    func: () => import(/* webpackChunkName: "testimonials" */ './components/testimonials.js'),
    selector: '.slider-testimonials',
  },
  services: {
    func: () => import(/* webpackChunkName: "services" */ './components/services.js'),
    selector: '.slider-services',
  },
  trigger: {
    func: () => import(/* webpackChunkName: "trigger" */ './components/trigger.js'),
    selector: '.nav-trigger',
  },
  footer: {
    func: () => import(/* webpackChunkName: "footer" */ './components/footer.js'),
    selector: 'footer',
  },
  scrollNav: {
    func: () => import(/* webpackChunkName: "scrollNav" */ './components/scrollNav.js'),
    selector: '[data-tab-nav]'
  },
  cookies: {
    func: () => import(/* webpackChunkName: "cookies" */ './components/cookies.js'),
    selector: '[data-cookies]',
  },
};

export default {

  components: {},

  init() {
    let _this = this;

    window.onload = function() {
      if (Object.keys(COMPONENTS).length) {
        Object.keys(COMPONENTS).forEach((handle) => {
          _this.loadComponent(COMPONENTS[handle], handle);
        });
      }
    };

    // if (Object.keys(COMPONENTS).length) {
    //   Object.keys(COMPONENTS).forEach((handle) => {
    //     _this.loadComponent(COMPONENTS[handle], handle);
    //   });
    // }
  },

  loadComponent(component, handle) {
    let _this = this;
    // Check to see if there are elements relating to this component on the page
    let el = document.querySelector(component.selector);
    if (el) {
      // if this component isn't in the scope of the site app then we need to load it
      if (!_this.components[handle]) {
        component.func().then(({ default: obj }) => {
          _this.components[handle] = obj;
          _this.components[handle].init(component.selector);
        });
      } else if (_this.components[handle]) {
        _this.components[handle].init(component.selector);
      }
    }
  },

};
